import {getStore} from 'redux-stores/Store';

import {ManagedModelType, ManagedModelTypes} from '../ManagedModelDefinitions';
import {modelFetched} from '../ManagedModelsReduxActions';
import {ManagedModelSelector} from '../reduceManagedModels';
import {ModelManager} from './ModelManager';

export type FetchModelsFn<T extends ManagedModelType> = (
  keys: Array<string>
) => Promise<{[key: string]: ManagedModelTypes[T]}>;

export default class ManagedModelManager<T extends ManagedModelType> extends ModelManager<T> {
  constructor(
    modelType: T,
    private readonly fetchModels: FetchModelsFn<T>
  ) {
    super(modelType);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    const modelsByKey = await this.fetchModels(keys);
    getStore().dispatch(modelFetched(this.modelType, modelsByKey));
  }

  getModel(modelKey: string): ManagedModelTypes[T] | null {
    return new ManagedModelSelector(getStore().getState()).getModel(this.modelType, modelKey);
  }
}
